<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">

      <v-data-table :headers="headers" :items="filteredList" class="elevation-1 mytable" dense :search="search">

        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Ordinance Rule Mapping</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"></span>

          <v-row dense align="center">
            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details />
            </v-col>

            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" small v-on="on">
                  Add Rule Mapping
                </v-btn>
              </template>

              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text class="pb-2 mt-2">
                    <v-col cols="12">
                      <v-icon color="error" small>*</v-icon>
                      <v-autocomplete label="Select Standard" v-model="standard" :items=standard_list item-text="name"
                        item-value="id" outlined required dense class="mt-2" />

                      <v-icon color="error" small>*</v-icon>
                      <v-autocomplete label="Select Rule" v-model="rule" :items=ordinance_rule_list item-text="name"
                        item-value="id" outlined required dense class="mt-2" />

                      <v-icon color="error" small>*</v-icon>
                      <v-text-field label="Enter Value" v-model="value" dense outlined type="number" />

                      <v-checkbox dense v-model="editedItem.isactive" color="success" label=" Is Active"
                        v-if="editedIndex !== -1" class="ml-4"></v-checkbox>
                    </v-col>
                  </v-card-text>

                  <v-card-actions class="justify-center pt-0">
                    <v-btn class="button" @click="close()" :disabled="!valid">
                      Cancel
                    </v-btn>

                    <v-btn color="primary button" @click="save" :disabled="!valid">
                      {{ editedIndex === -1 ? 'Save' : 'Update' }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>

          <v-row class="pa-2 mt-5" align="center" justify="center">
              <v-col
                v-for="header in headers"
                :key="header.value"
                cols="12"
                md="3"
                v-if="filters.hasOwnProperty(header.value)"
              >
                <v-autocomplete
                  v-model="filters[header.value]"
                  :items="columnValueList(header.value)"
                  :label="header.text"
                  multiple
                  clearable
                  dense
                  outlined
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>

            <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    standard: "",
    rule: "",
    value: "",
    selected_standard: "",
    selected_rule: "",
    dialog: false,
    headers: [
      {
        text: "Standard",
        align: "left",
        sortable: false,
        value: "standard",
      },
      {
        text: "Rule",
        align: "left",
        sortable: false,
        value: "rule",
      },
      {
        text: "Value",
        align: "left",
        sortable: false,
        value: "value",
      },
      {
        text: "Is Active",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      {
        text: " Actions",
        value: "action",
        sortable: false
      },
    ],
    ordinance_mapping_list: [],
    standard_list: [],
    ordinance_rule_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      standard: "",
      rule: "",
      value: "",
      isactive: true
    },
    defaultItem: {
      id: "",
      standard: "",
      rule: "",
      value: "",
      isactive: true
    },
    filters: {
      standard: [],
      rule: []
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Rule Mapping" : "Edit Rule Mapping";
    },
    filteredRuleList() {
      if (!this.search) return this.ordinance_mapping_list;

      const txt = this.search.toLowerCase();

      return this.ordinance_mapping_list.filter(item => (item.name || "").toLowerCase().includes(txt)
      );
    },
    filteredList() {
      return this.ordinance_mapping_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    downloadFile() {
      this.loader = true;

      const excelData = this.filteredList.map((item, index) => ({
        "S.No": index + 1,
        "Standard": item.standard,
        "Rule": item.rule,
        "Value": item.value,
        "Is Active": item.isactive
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ordinance Rule Mapping");
      XLSX.writeFile(workbook, "OrdinanceRuleMapping.xlsx");

      this.loader = false;
    },

    columnValueList(val) {
      return [...new Set(this.ordinance_mapping_list.map(d => d[val]))];
    },

    editItem(item) {
      this.editedIndex = this.ordinance_mapping_list.indexOf(item);

      this.editedItem = {
        id: item.id,
        standard: item.standard_id,
        rule: item.rule_id,
        value: item.value,
        isactive: item.isactive
      };

      this.standard = item.standard_id;
      this.rule = item.rule_id;
      this.value = item.value;

      this.dialog = true;
    },

    onLoad() {
      this.overlay = true;
      this.standard = "",
        this.rule = "",
        this.value = "",
        axios
          .post("/ordinanceRule/getRuleMapping")
          .then((res) => {
            this.overlay = false;
            if (res.data.msg == "200") {
              this.overlay = false;
              this.standard_list = res.data.standard_list;
              this.ordinance_rule_list = res.data.ordinance_rule_list;
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.overlay = false;
          });

      this.fetchRuleMapping();
    },

    fetchRuleMapping() {
      this.overlay = true;
      const data = {
        standard: this.selected_standard,
        rule: this.selected_rule
      }
      axios
        .post("/ordinanceRule/fetchRuleMapping", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.ordinance_mapping_list = res.data.rule_mapping_list;
            if (this.ordinance_mapping_list.length <= 0) {
              this.showSnackbar("#b71c1c", "No record found for this standard and value...");
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      this.standard = "",
        this.rule = "",
        this.value = "",
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          if (this.standard && this.rule && this.value) {
            this.editedItem.standard = this.standard;
            this.editedItem.rule = this.rule
            this.editedItem.value = this.value
          } else {
            this.showSnackbar("#b71c1c", "Select all fields");
            return
          }
          axios
            .post("/ordinanceRule/editRuleMapping", this.editedItem)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                this.showSnackbar("#4caf50", "Ordinance Rule Mapping Updated Successfully...");
                this.close();
                this.fetchRuleMapping()
              } else if (res.data.code == "NA") {
                this.showSnackbar("#b71c1c", res.data.msg || "Ordinance Rule Mapping Already Present!!!");
              } else {
                this.showSnackbar("#b71c1c", "Something went wrong!");
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
        }
      } else {
        if (this.standard && this.rule && this.value) {
          const payload = {
            standard: this.standard,
            rule: this.rule,
            value: this.value
          }
          axios
            .post("/ordinanceRule/saveRuleMapping", payload)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                this.showSnackbar("#4caf50", "Ordinance Rule Mapping Added Successfully...");
                this.fetchRuleMapping();
              } else if (res.data.code == "NA") {
                this.showSnackbar("#b71c1c", res.data.msg || "Ordinance Rule Mapping Already Present!!!");
              } else {
                this.showSnackbar("#b71c1c", "Something went wrong...");
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        } else {
          this.showSnackbar("#b71c1c", "Select all fields");
        }
      }
    },

    isValidated() {
      if (this.editedItem.standard && this.editedItem.rule && this.editedItem.value) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }
        return false;
      }
    },

    toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/ordinanceRule/toggleRuleMapping", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Ordinance Rule Mapping Updated Successfully!");
            this.fetchRuleMapping();
          } else if (res.data.code == "NA") {
            this.showSnackbar("#4caf50", "Something went wrong, Please try again later!");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this Mapping?")) {
        const data = {
          id: item.id
        };
        axios
          .post("/ordinanceRule/deleteRuleMapping", data)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Ordinance Rule Mapping Deleted Successfully...");
              this.fetchRuleMapping();
            } else {
              this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
      this.close();
    }
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable /deep/ thead th {
  background: #0f2027;
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>